import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { UpdatesResponse } from '@manaro/contracts'
import { queryKeys } from '@/shared/api/query-keys.ts'
import { fetchUpdates } from './api.ts'

export function useUpdates() {
  return useQuery({
    queryKey: queryKeys.updates,
    queryFn: ({ signal }) => fetchUpdates({ signal }),
    staleTime: 5 * 60 * 1000,
  })
}

export function useRefreshUpdates() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () => fetchUpdates({ refresh: true }),
    onSuccess: (data: UpdatesResponse) => {
      queryClient.setQueryData(queryKeys.updates, data)
    },
  })
}
